module.exports = __webpack_public_path__ + "static/media/list.51de9bcf.svg";